import Rails from '@rails/ujs';
import 'core-js/stable';

// Stimulus
import '@stimulus/polyfills';
import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

// Utils
import { initModal } from './utils/modal';
import { reactContext, stimulusContext } from './config/context';
import initAnalytics from './analytics';
import initNavAccordionAnimation from './utils/nav_accordion_animation_handler';
import 'flowbite';


// Turbo (with drive disabled since we aren't ready for it)
import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = false;

// Analytics
initAnalytics();

// Misc
Rails.start();
document.addEventListener('DOMContentLoaded', () => {
  initModal();
});

// Stimulus Init
const application = Application.start();
application.load(definitionsFromContext(stimulusContext));

// React
/* eslint-disable react-hooks/rules-of-hooks */
const ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(reactContext);
/* eslint-disable react-hooks/rules-of-hooks */

// Nav Accordion Animations
initNavAccordionAnimation();
